<header class="header-internet">
  <div class="header-internet__navigation">
    <ng-container *ngIf="{ rechner: rechner | async, produktseite: produktseite | async } as result">
      <ng-container *ngIf="result.rechner && result.produktseite">
        <div class="container">
          <div class="header-internet__navigation-mobile">
            <a class="header-internet__navigation-desktop__menu-primary__logo" href="{{ result.produktseite.Produktseite }}">
              <img src="assets/img/hdi_logo.svg" alt="HDI-Logo">
              <h1>{{ result.rechner.Rechner }}</h1>
            </a>
          </div>
          <div class="header-internet__navigation-desktop">
            <div class="header-internet__navigation-desktop-main">
              <div class="header-internet__navigation-desktop__menu-primary__logo">
                <a href="{{ result.produktseite.Produktseite }}">
                  <img src="assets/img/hdi_logo.svg" alt="HDI-Logo">
                </a>
                <h1>{{ result.rechner.Rechner }}</h1>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</header>
